//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/tableOfContentsHistoryModalTemplate.html"], function (
  Marionette,
  TableOfContentsHistoryModalTemplate,
) {
  "use strict";

  var TableOfContentsHistoryModalView = {};

  TableOfContentsHistoryModalView.tableOfContentsHistoryModalLayout = Marionette.Layout.extend({
    template: TableOfContentsHistoryModalTemplate,
    regions: {
      tableOfContentsHistory: "#tableOfContentsHistory",
    },
    triggers: {
      "click #doneButton": "done",
    },
  });

  return TableOfContentsHistoryModalView;
});
